import React from 'react';
interface HighlightProps {
  children: React.ReactNode;
  color?: 'primary' | 'urgency';
}
export function Highlight({
  children,
  color = 'primary'
}: HighlightProps) {
  const colors = {
    primary: 'text-primary',
    urgency: 'text-urgency'
  };
  return <span className={`${colors[color]} font-bold`} data-id="element-153">{children}</span>;
}